import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';
import { IdInterface, ValidationInterface } from '../data';

@Injectable()
export class ValidationRepository {
    private data: Map<string, ValidationInterface> = new Map();

    constructor(private transactionRequest: TransactionRequestInterface) {}

    load(id: IdInterface): Observable<Transaction<ValidationInterface>> {
        if (this.data.has(id.value)) {
            return this.transactionRequest.wrap(of(this.data.get(id.value)));
        }

        return of(Transaction.error());
    }

    update(validation: ValidationInterface): Observable<Transaction<void>> {
        return this.transactionRequest.wrap(
            new Observable((observer: any) => {
                this.data.set(validation.id.value, validation);

                observer.next(Transaction.success());
                observer.complete();
            })
        );
    }
}
